import axios from 'axios';

const RestfulGet = (url, handleResponse, handleError) => {
  return(
    axios.get('/api/index.php/' + url)
      .then((response) => handleResponse(response))
      .catch((error) => handleError(error))
  )
}

const RestfulPost = (url, data, handleResponse, handleError) => {
  var qs = require('qs');
  return(
    axios.post('/api/index.php/' + url, qs.stringify(data))
      .then((response) => handleResponse(response))
      .catch((error) => handleError(error))
  )
}

const RestfulUpload = (url, data, handleResponse, handleError) => {
  return(
    axios.post('/api/index.php/' + url, data, {
      headers: { 'content-type': 'multipart/form-data' }
    })
      .then((response) => handleResponse(response))
      .catch((error) => handleError(error))
  )
}

export { RestfulGet, RestfulPost, RestfulUpload };



// WEBPACK FOOTER //
// ./src/Api/Restful.js